<template>
    <nav class="inventory-header">
        <RouterLink
            class="inventory-header__link"
            active-class="inventory-header__link_active"
            :key="link.label"
            :to="link.to"
            v-for="link in links"
        >
            {{ link.label }}
        </RouterLink>
    </nav>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';

/**
 * Навигация по разделам модуля «Оборудование».
 *
 * Заменяет левое меню (VSidebar в слоте menu), которое у модуля было своим собственным:
 * теперь слева общее меню Service Desk, а разделы модуля живут в шапке страницы.
 *
 * Подсветка активного раздела — штатным active-class роутера, а не сверкой имён маршрутов:
 * он метит ссылку активной и на вложенных путях, поэтому «Справочники» остаются подсвечены
 * на /inventory/attributes/:type, а «Оборудование» — на карточке предмета.
 */
@Component()
class VInventoryHeader extends Vue {
    links = [
        { label: 'Оборудование', to: { name: 'inventory.items' } },
        { label: 'Шаблоны', to: { name: 'inventory.presets' } },
        { label: 'Держатели', to: { name: 'inventory.holders' } },
        { label: 'Справочники', to: { name: 'inventory.attributes' } },
    ];
}

export default VInventoryHeader;
</script>
<style lang="scss">
.inventory-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    padding: 16px 36px 0 36px;

    &__link {
        display: inline-flex;
        align-items: center;
        padding: 8px 16px;
        border-radius: 8px;
        color: #3c4043;
        font-size: 0.9rem;
        font-weight: 500;
        line-height: 1;
        white-space: nowrap;
        text-decoration: none;
        transition: background 0.15s, color 0.15s;

        &:hover {
            background: #f6f7f8;
        }

        // Заливка активного состояния захардкожена так же, как в соседних компонентах
        // (RequestStatsBar, ColumnSettingsMenu, BaseToolsSort): токена под неё в проекте нет,
        // и заводить первый ради одной навигации не стоит.
        &_active {
            background: #e8f5e9;
            color: #2e7d32;
            font-weight: 600;
        }
    }
}
</style>
